export default ".modal-header {\n  width: 500px;\n  background-color: #4cbca3;\n  font-family: \"probold\";\n}\n\n.modal-body p {\n  text-align: justify;\n}";